import api from '@/api/api'
import router from '@/router/index'

export default {
  namespaced: true,
  state: {
    user: {
      id: null,
      msisdn: null,
      sid: null,
      status: null,
      metadata: null,
      startDate: null,
      endDate: null,
      lastBillingStatus: null,
      lastBillingDate: null
    },
    bajaTramitada: false,
    loaded: false,
    sessionChecked: false,
    checkingSession: false
  },
  mutations: {
    setUser(state, user) {
      state.user = Object.assign(state.user, user)
    },
    setBajaTramitada(state, payload) {
      state.bajaTramitada = payload
    },
    logout(state) {
      state.user.id = null
    },
    loaded(state, payload) {
      state.loaded = payload
    },
    sessionChecked(state, payload) {
      state.sessionChecked = payload
    },
    checkingSession(state, payload) {
      state.checkingSession = payload
    }
  },
  actions: {
    restore({ commit }) {
      const userJson = localStorage.getItem('user')
      let user = null
      if (userJson !== null) {
        user = JSON.parse(userJson)
      }
      if (user !== null) {
        commit('setUser', user)
        commit('setBajaTramitada', false)
      }
    },
    async login({ commit }, { msisdn, access }) {
      const response = await api.post('/login/login', {
        msisdn,
        access
      })
      const user = {
        id: response.data.sid,
        msisdn: response.data.msisdn,
        sid: response.data.sid,
        status: response.data.status,
        metadata: response.data.metadata,
        startDate: response.data.startDate,
        endDate: response.data.endDate,
        lastBillingStatus: response.data.lastBillingStatus,
        lastBillingDate: response.data.lastBillingDate
      }
      localStorage.setItem('user', JSON.stringify(user))
      commit('setUser', user)
      commit('sessionChecked', true)
      commit('setBajaTramitada', false)
    },
    async loginApn({ commit }, { token, operator, access }) {
      const response = await api.post('/login/login_apn', {
        token,
        operator,
        access
      })
      const user = {
        id: response.data.sid,
        msisdn: response.data.msisdn,
        sid: response.data.sid,
        status: response.data.status,
        metadata: response.data.metadata,
        startDate: response.data.startDate,
        endDate: response.data.endDate,
        lastBillingStatus: response.data.lastBillingStatus,
        lastBillingDate: response.data.lastBillingDate
      }
      localStorage.setItem('user', JSON.stringify(user))
      commit('setUser', user)
      commit('sessionChecked', true)
      commit('setBajaTramitada', false)
    },
    async enrichment() {
      const response = await api.get('/login/get_enrichment_url')
      window.location.replace(response.data.url)
    },
    async logout({ commit }) {
      try {
        await api.post('/login/logout')
        // eslint-disable-next-line
      } catch (e) {
      } finally {
        localStorage.removeItem('redirectAfterLogin', null)
        localStorage.removeItem('login', null)
        localStorage.removeItem('access', null)
        localStorage.removeItem('user', null)
        commit('logout')
        router.push({ name: 'login' })
      }
    },
    async enrichmentUnsubscribe() {
      const response = await api.get('/login/get_enrichment_unsubscribe_url')
      window.location.replace(response.data.url)
    },
    async unsubscribeAuto({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .post('/login/unsubscribe_auto')
          .then(response => {
            commit('setBajaTramitada', true)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async unsubscribe({ commit }, { operationId, correlationId }) {
      return new Promise((resolve, reject) => {
        api
          .post('/main/cancel_subscription', {
            operationId,
            correlationId
          })
          .then(response => {
            commit('setBajaTramitada', true)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async checkSession({ commit, dispatch }) {
      try {
        await api.get('/login/check_session')
        commit('sessionChecked', true)
        dispatch('viralmobile/getData', null, { root: true })
      } catch (e) {
        commit('logout')
        localStorage.removeItem('user')
        throw e
      }
    },
    setLoaded({ commit }, payload) {
      commit('loaded', payload)
    },
    setSessionChecked({ commit }, payload) {
      commit('sessionChecked', payload)
    },
    setCheckingSession({ commit }, payload) {
      commit('checkingSession', payload)
    }
  },
  getters: {
    user(state) {
      return state.user
    },
    cookie() {
      return name => {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim()
          if (cookie.startsWith(name + '=')) {
            console.log(cookie.substring(name.length + 1))
            return cookie.substring(name.length + 1)
          }
        }
        return null
      }
    },
    bajaTramitada(state) {
      return state.bajaTramitada
    },
    loaded(state) {
      return state.loaded
    },
    sessionChecked(state) {
      return state.sessionChecked
    },
    checkingSession(state) {
      return state.checkingSession
    },
    loggedIn(state) {
      return state.user.id != null
    }
  }
}
